import PropTypes from 'prop-types';
import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SCENARIOS, CONTEXT } from 'woop-shared/enums';
import { CONNECT_ROUTE_PAGES, ROUTES } from '../../../../../../router/constants/routes';
import { connectRoute } from '../../../../../../router/utils';
import { patchJourney, PATCH_JOURNEY } from '../../../../../journey/actions/journey';
import { postQuoteset } from '../../../../../quote/actions';
import { clearCanopy } from '../../../../actions/canopy';
import { setScenario } from '../../../../actions/scenario';
import { QUERY_PARAMS } from '../../../../constants/url';
import { useDealershipPartnerName } from '../../../../hooks/use-dealership-partner-name';
import { getQueryStringParam } from '../../../../utils/url';
import Button from '../../../Button';
import Checkbox from '../../../Checkbox';
import H3 from '../../../headers/H3';
import LinkText from '../../../LinkText';
import SuccessCheckmark from '../../../SuccessCheckmark';
import styles from './styles.css';
import { getButtonText, getText, showConnectAnother } from './utils';

const SuccessScreen = ({ onContinue }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(true);
  const partnerName = useDealershipPartnerName();
  const {
    canopy: { carrier = {} },
    loading,
    router,
    user
  } = useSelector(state => state);

  const isLoading = loading.includes(PATCH_JOURNEY);
  const scenario = getQueryStringParam(QUERY_PARAMS.SCENARIO);

  const handleIvClick = () => {
    const shouldSignup = checked && !user.exists;
    if (shouldSignup) dispatch(setScenario(SCENARIOS.SIGN_UP));
    const callback = shouldSignup
      ? () =>
          dispatch(
            postQuoteset({
              notifyConsumer: false,
              redirect: false,
              context: CONTEXT.IV
            })
          )
      : null;
    dispatch(patchJourney({ callback }));
    history.push(ROUTES.IV_END);
  };

  return (
    <div className={styles.wrapper}>
      <section className={styles.content}>
        <SuccessCheckmark />
        <H3>Connected</H3>
        <p className={styles.text}>{getText({ scenario, carrier: carrier.name, partnerName })}</p>
      </section>

      <section className={styles.footer}>
        {scenario === SCENARIOS.IV && (
          <div className={styles.check}>
            <Checkbox value={checked} save={setChecked} light>
              Include my free insurance report
            </Checkbox>
          </div>
        )}

        <Button
          useKeyboard
          onClick={scenario === SCENARIOS.IV ? handleIvClick : onContinue}
          className={styles.button}
          showArrow
          blockButtonMobile
          loading={isLoading}
        >
          {getButtonText({ scenario })}
        </Button>

        {showConnectAnother(scenario) && (
          <LinkText
            onClick={() => {
              dispatch(clearCanopy());
              history.replace(connectRoute(router.location.pathname, CONNECT_ROUTE_PAGES.CARRIERS));
            }}
          >
            Connect another policy
          </LinkText>
        )}
      </section>
    </div>
  );
};

SuccessScreen.propTypes = {
  onContinue: PropTypes.func
};

export default SuccessScreen;
